import React             from 'react';
import PropTypes         from '../PropTypes';
import ProjectActionList from '../ProjectActionList';
import ComponentHelper   from '../../helper/ComponentHelper';

class TableProjectActionsFormatter extends React.Component {
    render () {
        return (
            <ProjectActionList project={this.props.value} />
        );
    }

    shouldComponentUpdate (nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            Component,
            nextProps,
            nextState,
        );
    }
}

const Component = TableProjectActionsFormatter;

Component.propTypes = {
    value: PropTypes.any,
};

Component.defaultProps = {
    value: [],
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;